import React from 'react';
import {Fecha as FechaComponent} from '../../../../../componentes/Fecha.js'
import { TrashIcon } from '@heroicons/react/24/outline';

export const FechaActa = ({estadoOcultoOConsolidado,handleChangeFecha,fecha,titulo}) => {

    if(estadoOcultoOConsolidado){
        return   <div className="flex flex-col items-start gap-1 cursor-not-allowed">
      <span className="text-xs font-medium text-gray-500 mb-1">{titulo}</span>
      <div className="text-sm font-semibold text-gray-800 bg-gray-50 px-3 py-2 rounded-md border border-gray-200 w-full min-h-[38px] flex items-center">
            {fecha ? fecha.toLocaleDateString('es-AR') : "—"}
      </div>
    </div>
    }

    return  <label className="flex flex-col items-start gap-2 cursor-pointer">
      <span className="text-xs font-medium text-gray-700">{titulo}</span>                                    
      <div className='flex'>
            <FechaComponent
                disabled={false} 
                fecha={fecha}
                setFecha={handleChangeFecha}
            />
            <TrashIcon 
                width={15} 
                height={15} 
                title='Borrar la fecha'
                className='cursor-pointer hover:opacity-85 mt-2 ml-1' 
                onClick={() => handleChangeFecha(null)}
            />
      </div>
    </label>
};